import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import moment from 'moment';
import momentJalaali from 'moment-jalaali';
import Target from 'ol/events/Target';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'Support',

  templateUrl: './support.component.html',

  // styleUrls: ['../temp-access-admin/temp-access-admin.component.css']

  styles: [`

      .modal-body{
          
          direction: rtl;
      }

      .section {
          overflow: auto;
      }

      #Export_Excel {
          overflow-x: auto;
          white-space: nowrap;

      }

      textarea{
          height:150px;
          resize: none;
      }
    
    `]

})

export class SupportComponent implements OnInit {

  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private _location: Location,
    private gurdService: GurdServiceService
  ) { }

  Id: number = 0;

  Support: any;

  ServiceTxt: any;

  singelSupport: any;

  tiketStatus: any;

  Actions: any;

  sabtModel: FormGroup = this.formBuilder.group({
    tiTiketSubject: new FormControl(),
    strDetail: new FormControl(),
  });

  editModel = new FormGroup({
    iTiket: new FormControl(),
    tiTiketSubject: new FormControl(),
    strDetail: new FormControl(),
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  });

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.Id = params['id'];
      // this.sabtModel.controls['strUnitId'].setValue(this.Id);
    });

    this.getAllSupport();
    this.getOption();
  }

  goBack() {
    this._location.back();
  }

  getOption = async () => {
    const resp2 = await axios.post(
      `Tiket_GetTiketSubjects`
    );
    this.ServiceTxt = resp2.data;

    this.sabtModel.controls['tiTiketSubject'].setValue("");
  };

  getAllSupport = async () => {

    const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

    const resp = await axios.post(`Tiket_GetTiket4Mobile?strUnitID=${this.Id}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`);

    if (resp.data == null) {

      this.notifyService.showError('بروز خطا در سیستم');

      return;

    }

    if (resp.data.length == 0) {
      
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
      
      this.Support = resp.data;
      
    } 
    
    else {
      this.Support = resp.data;
    }
  };

  sabt = async () => {
    var model = this.sabtModel.value;
    model.strUnitId = this.Id;
    model.iSystemUser = this.gurdService.decrypt(window.localStorage.getItem('ID')!);
    if (model.iSystemUser == null || model.iSystemUser == "") {
      this.notifyService.showError("لطفا وارد شوید ");
      return;
    }
    if (model.tiTiketSubject == null || model.tiTiketSubject == "") {
      this.notifyService.showError("لطفا  موضوع تیکت را وارد کنید");
      return;
    }
    if (model.strDetail == null || model.strDetail == "") {
      this.notifyService.showError("لطفا  توضیحات را وارد کنید");
      return;
    }
    if (confirm('آیا از ارسال درحواست اطمینان دارید؟')) {

      const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

      const resp = await axios.post(`Tiket_SaveTiket?strSession=${session}`, model);
      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        // this.router.navigate(['/login']);
        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 7 } });
        return;
      }
      if (resp.data == 0) {
        this.notifyService.showError('خطایی رخ داده');
      }

      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت ثبت شد');
        this.getAllSupport();
        $('#exampleModal').modal('hide');
      }


    }
  };

  singel = async (i: any) => {

    this.singelSupport = this.Support[i];

    const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

    const resp = await axios.post(`Tiket_GetTiketAction?iTiket=${this.singelSupport.iTiket}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`);

    this.Actions = resp.data;

    this.getTiketStatus(i);

    this.editModel.controls["iTiket"].setValue(this.singelSupport.iTiket);

    // console.log(this.singelSupport)

    // console.log(this.Actions)

  }

  seprator(e: any) {
    this.otherService.insertComma(e);
  }

  Cancellation = async () => {
    if (confirm("آیا از لغو این تیکت اطمینان دارید؟")) {
      const resp = await axios.post(
        `Tiket_CancelTiket?strSession=${this.gurdService.decrypt(localStorage.getItem('Session')!)}`
        , this.singelSupport);
      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        // this.router.navigate(['/login']);
        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 8 } });
        return;
      }
      if (resp.data == 0) {
        this.notifyService.showError('خطایی رخ داده');
      }
      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت لغو شد');
        this.getAllSupport();
        $('#exampleModal2').modal('hide');
      }
    }

  }

  guid(Id: any) {
    this.otherService.guid(Id);
  }

  getTiketStatus = async (id: any) => {

    var model = {
      iTiket: id,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    }

    const resp = await axios.post(`Tiket_GetTiketStatus4User`, model);

    this.tiketStatus = JSON.parse(resp.data);

    // console.log(this.tiketStatus)

    setTimeout(() => {
      this.editModel.controls["tiTiketSubject"].setValue(this.singelSupport.tiTiketStatus);
      this.editModel.controls["strDetail"].setValue(this.singelSupport.strDetail);
    }, 100);

  }

  edit = async () => {

    var model = this.editModel.value

    const resp = await axios.post(`Tiket_EditTiket`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);

    }

    else {
      $("#exampleModal2").modal("hide");
      this.getAllSupport();
      this.notifyService.showSuccess("با موفقیت ویرایش شد");
    }

  }

  filter_list(val: any) {

    // this.list_Result = this.list_Search.filter((el: any) => {

    //   return el.strFullName.includes(val.value) ||

    //     el.strMobile.includes(val.value) ||

    //     el.strSDate.includes(val.value) ||

    //     el.strEDate.includes(val.value)

    // });

    // if (val.value.trim() == '') {

    //   this.list_Result = this.list_Search;

    // }

  }


}
